import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

interface AppToastProps {
  visible: boolean;
  message: string;
  type?: 'success' | 'error' | 'info';
  bottom?: number;
}

export default function AppToast({ visible, message, type = 'info', bottom = 16 }: AppToastProps) {
  if (!visible || !message) return null;

  const backgroundColor = type === 'success' ? '#16a34a' : type === 'error' ? '#dc2626' : '#334155';

  return (
    <View
      style={[styles.container, { backgroundColor, bottom }]}
      accessibilityRole="alert"
      pointerEvents="none"
    >
      <Text style={styles.text}>{message}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    left: 16,
    right: 16,
    paddingHorizontal: 14,
    paddingVertical: 10,
    borderRadius: 12,
    zIndex: 1200,
    elevation: 6,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.2,
    shadowRadius: 6,
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.2)',
  },
  text: {
    color: '#ffffff',
    fontSize: 13,
    fontWeight: '600',
    textAlign: 'center',
  },
});
